/**
 * 任务相关（包含任务组）
 */

import StoreDecorator, {
  Action,
  Mutation,
  Getter,
  AutoLoading
} from '@acgn/herm/lib/store-decorator';

import {
  createTask,
  editTask,
  getTaskList,
  getTaskDetail,
  createTaskGroup,
  setStatusTaskGroup,
  setStatusTask,
  eidtTaskGroup,
  getLinks,
  addTemplate,
  getTaskGroupList,
  getTaskGroupStatus,
  getTaskStatus,
  editLinkInfo,
  resetLink,
  getlistByLinkid,
  getDetailByid,
  submitFile,
  recycleBin,
  recycleBinTask,
  setStoverDuestatus,
  setGroupOrder,
  setTaskOrder,
  getTaskCycleStatus,
  setLinkStatus,
  editLinkPrice,
} from '../../api/taskGroup';

interface StateType {
  taskGroupList?: any; // 漫画项目列表
  taskList?: any;
}
@StoreDecorator
@AutoLoading
class StoreModule {
  public state() {
    return {
      taskGroupList: {},
      taskList: {}
    };
  }

  // 新建任务
  @Action()
  public async createTask(state: StateType, payload: any) {
    return await createTask(payload);
  }

  // 编辑任务
  @Action()
  public async editTask(state: StateType, payload: any) {
    return await editTask(payload);
  }

  // 获取任务组下的任务
  @Action()
  public async getTaskList(state: StateType, payload: any) {
    return await getTaskList(payload);
  }

  // 获取任务详情
  @Action()
  public async getTaskDetail(state: StateType, options: any) {
    return await getTaskDetail(options);
  }

  // 新建任务组
  @Action()
  public async createTaskGroup(state: StateType, option: any) {
    return await createTaskGroup(option);
  }

  // 删除/恢复任务组
  @Action()
  public async setStatusTaskGroup(state: StateType, option: any) {
    return await setStatusTaskGroup(option);
  }

  // 删除/恢复任务
  @Action()
  public async setStatusTask(state: StateType, option: any) {
    return await setStatusTask(option);
  }

  // 编辑任务组
  @Action()
  public async eidtTaskGroup(state: StateType, option: any) {
    return await eidtTaskGroup(option);
  }

  // 添加任务获取任务默认环节
  @Action()
  public async getLinks(state: StateType, option: any) {
    return await getLinks(option);
  }

  // 添加任务添加环节
  @Action()
  public async addTemplate(state: StateType, option: any) {
    return await addTemplate(option);
  }

  // 修改环节数
  @Action()
  public async editLinkInfo(state: StateType, option: any) {
    return await editLinkInfo(option);
  }

  // 重置环节
  @Action()
  public async resetLink(state: StateType, option: any) {
    return await resetLink(option);
  }

  // 多审批列表
  @Action()
  public async getlistByLinkid(state: StateType, option: any) {
    return await getlistByLinkid(option);
  }

  // 审批详情
  @Action()
  public async getDetailByid(state: StateType, option: any) {
    return await getDetailByid(option);
  }

  // 提交画稿
  @Action()
  public async submitFile(state: StateType, option: any) {
    return await submitFile(option);
  }

  // 任务组回收站
  @Action()
  public async recycleBin(state: StateType, option: any) {
    return await recycleBin(option);
  }

  // 验证任务组回收状态
  @Action()
  public async getTaskCycleStatus(state: StateType, option: any) {
    return await getTaskCycleStatus(option);
  }

  // 任务回收站
  @Action()
  public async recycleBinTask(state: StateType, option: any) {
    return await recycleBinTask(option);
  }

  // 修改逾期状态
  @Action()
  public async setStoverDuestatus(state: StateType, option: any) {
    return await setStoverDuestatus(option);
  }

  // 修改任务组排序
  @Action()
  public async setGroupOrder(state: StateType, option: any) {
    return await setGroupOrder(option);
  }

  // 修改任务组排序
  @Action()
  public async setTaskOrder(state: StateType, option: any) {
    return await setTaskOrder(option);
  }

  // 获取任务和状态
  @Action()
  public async getTaskStatus(state: StateType, option: any) {
    return await getTaskStatus(option);
  }

  // 获取任务组
  @Action()
  public async getTaskGroupList(state: StateType, option: any) {
    return await getTaskGroupList(option);
  }
  // 设置状态
  @Action()
  public async setLinkStatus(state: StateType, option: any) {
    return await setLinkStatus(option);
  }
  // 设置价格
  @Action()
  public async editLinkPrice(state: StateType, option: any) {
    return await editLinkPrice(option);
  }

  // 获取任务组和状态
  @Action('setTaskGroupList')
  public async getTaskGroupStatus({ commit, state }: any, option: any) {
    return await getTaskGroupStatus(option);
  }

  // 设置任务组列表
  @Mutation('taskGroupList')
  public setTaskGroupList(state: StateType, payload: any) {
    return payload;
  }

  // 设置任务列表
  @Mutation('taskList')
  public setTaskList(state: StateType, payload: any) {
    return payload;
  }

  // 任务组列表
  @Getter
  public taskGroupStatusList(state: StateType) {
    return state.taskGroupList;
  }

  // 任务组列表
  @Getter
  public taskList(state: StateType) {
    return state.taskList;
  }
}

export default new StoreModule();
